import DataTable from "react-data-table-component"
import { ChevronDown } from "react-feather"
import { customStyles } from "./styles"
import PaginationComponent from "../PaginationComponent/PaginationComponent"

const DynamicDatatable = ({ data, columns, type, pagination = false, ...rest }) => {
  const styles = customStyles[type]
  return (
    <DataTable
      data={data}
      columns={columns}
      sortIcon={<ChevronDown />}
      pagination={pagination}
      paginationComponent={pagination ? PaginationComponent : undefined}
      customStyles={styles}
      {...rest}
    />
  )
}

export default DynamicDatatable
